var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: "日志",
            visible: _vm.Open,
            width: "660px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.Open = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "max-height": "600px", overflow: "auto" } },
            [
              _c("BaseTable", {
                ref: "baseTable",
                attrs: { "fn-init": _vm.Fninit, table: _vm.table },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }